import { render, staticRenderFns } from "./index.vue?vue&type=template&id=81c0fb86&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=81c0fb86&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c0fb86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81c0fb86')) {
      api.createRecord('81c0fb86', component.options)
    } else {
      api.reload('81c0fb86', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=81c0fb86&scoped=true", function () {
      api.rerender('81c0fb86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/payPopup/index.vue"
export default component.exports